const multiSelectSearchStyles = {
  option: (base) => ({
    ...base,
    color: "#333536",
    backgroundColor: "#FFFFFF",
    ":active": {
      color: "#333536",
      backgroundColor: "#F6F7FD",
    },
    ":hover": {
      color: "#3399FF",
      backgroundColor: "#F6F7FD",
    },
    padding: "0.5rem 1rem",
    fontWeight: 500,
    textOverflow: "ellipsis",
    cursor: "pointer",
  }),
  control: (base) => ({
    ...base,
    flexWrap: "nowrap",
    width: "100%",
    "&:hover": { borderColor: "#EFF0F6" },
    boxShadow: "none",
    borderColor: "#EFF0F6",
    fontWeight: 600,
  }),
  singleValue: (base) => ({
    ...base,
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: "transparent",
  }),
  clearIndicator: (base) => ({
    ...base,
    backgroundColor: "transparent",
    color: "#3399FF",
    fontWeight: 400,
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    width: 30,
    color: state.isFocused ? "#333536" : "#CCCCCC",
  }),
  menu: (base) => ({
    ...base,
    boxShadow: "0 4px 8px 0 rgba(52, 58, 64, 0.15)",
    border: "solid 1px #EFF0F6",
    minWidth: 165,
    maxHeight: 240,
    width: "auto",
    zIndex: 100,
  }),
  menuList: (base) => ({
    ...base,
    padding: "0px",
    minWidth: 235,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#EFF0F6",
    borderRadius: 10,
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#3399FF",
    fontSize: "1rem",
    fontWeight: 500,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#3399FF",
    fontSize: "1rem",
    fontWeight: 500,
    ":hover": {
      color: "#3399FF",
      backgroundColor: "#EFF0F6",
      borderRadius: 10,
    },
  }),
  input: () => ({
    position: "absolute",
    color: "#333536",
    height: "36px",
  }),
  placeholder: (base) => ({
    ...base,
    position: "relative",
    lineHeight: "2.5rem",
  }),
  valueContainer: (base, state) => ({
    ...base,
    color: "#3399FF",
    width: state.isSelected ? "35%" : "70%",
    padding: "0 8px",
    flexWrap: "nowrap",
    height: "30px",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    justifyContent: "space-between",
  }),
};

export default multiSelectSearchStyles;
